module.exports = __webpack_public_path__ + "24e004ab/img/lock-icon.bb9c7166.svg";